import { render, staticRenderFns } from "./compIntoRecord.vue?vue&type=template&id=4fba48e8&"
import script from "./compIntoRecord.vue?vue&type=script&lang=js&"
export * from "./compIntoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports